import { render, staticRenderFns } from "./TableInteractive.vue?vue&type=template&id=1f67792f"
import script from "./TableInteractive.vue?vue&type=script&lang=js"
export * from "./TableInteractive.vue?vue&type=script&lang=js"
import style0 from "./TableInteractive.vue?vue&type=style&index=0&id=1f67792f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports